__turbopack_context__.v({
  "pill": "_3bjTYW_pill",
});
